import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const FilamentSelector = ({ selectedFilament, onFilamentChange, filaments }) => {
  const filamentOptions = filaments?.map(filament => ({
    value: filament?.id,
    label: `${filament?.brand} ${filament?.material}`,
    description: `${filament?.color} - R$ ${filament?.pricePerKg}/kg`
  }));

  const selectedFilamentData = filaments?.find(f => f?.id === selectedFilament);

  return (
    <div className="bg-card rounded-2xl border border-border p-6">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center">
  <Icon name="Filament" size={20} className="text-secondary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Selecionar Filamento</h3>
          <p className="text-sm text-muted-foreground">Escolha o material para impressão</p>
        </div>
      </div>
      <Select
        label="Filamento"
        placeholder="Selecione um filamento"
        options={filamentOptions}
        value={selectedFilament}
        onChange={onFilamentChange}
        required
        searchable
        className="mb-4"
      />
      {selectedFilamentData && (
        <div className="mt-4 p-4 bg-muted/50 rounded-lg">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-3">
              <div 
                className="w-8 h-8 rounded-full border-2 border-border"
                style={{ backgroundColor: selectedFilamentData?.colorHex }}
              />
              <div>
                <div className="font-medium text-foreground">{selectedFilamentData?.color}</div>
                <div className="text-sm text-muted-foreground">{selectedFilamentData?.material}</div>
              </div>
            </div>
            <div className="text-right">
              <div className="font-semibold text-foreground">R$ {selectedFilamentData?.pricePerKg}</div>
              <div className="text-sm text-muted-foreground">por kg</div>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-muted-foreground">Estoque:</span>
              <span className="ml-2 font-medium text-foreground">
                {selectedFilamentData?.stock}g
              </span>
            </div>
            <div>
              <span className="text-muted-foreground">Densidade:</span>
              <span className="ml-2 font-medium text-foreground">
                {selectedFilamentData?.density}g/cm³
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilamentSelector;
